import { render, staticRenderFns } from "./SaltSpreadingMeasurementFragment.vue?vue&type=template&id=195d67b0&scoped=true&"
import script from "./SaltSpreadingMeasurementFragment.vue?vue&type=script&lang=js&"
export * from "./SaltSpreadingMeasurementFragment.vue?vue&type=script&lang=js&"
import style0 from "./SaltSpreadingMeasurementFragment.vue?vue&type=style&index=0&id=195d67b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195d67b0",
  null
  
)

/* custom blocks */
import block0 from "./SaltSpreadingMeasurementFragment.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports